import mockData from './../mock/getOrder.json'
const shoppingCartApiElement = document.getElementById('shopping-cart');
const baseUrl = shoppingCartApiElement.getAttribute('data-shoppingcard-api-base-url');

const mockRequest = async (value) => {
  return new Promise((resolve) => {
    resolve({
      "status": {
        "code": value ? "OK" : "NOK",
        "message": value ? "Dein Code ist aktiviert" : "Dein Code ist ungültig"
      },
      "data": null
    });
  });
};

const mockGetOrder = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        status: {
          code: 'OK',
          message: 'Successfully fetched shopping cart'
        },
        data: mockData.data
      });
    }, 1000);
  });
};

const shoppingCartService = {

  getShoppingCartData: async () => {
    if (process.env.NODE_ENV === 'development') {
      return mockGetOrder();
    }

    const url = `${baseUrl}/api/lotterie/checkout/order/get`;
    try {
      const headers = {
        'Content-Type': 'application/json'
      };

      const response = await fetch(url, {
        method: 'GET',
        headers: headers,
      });

      if (response.ok) {
        const responseData = await response.json();
        return responseData;
      } else {
        console.error('Error GET request:', response.status);
        return null;
      }
    } catch (error) {
      console.error('Error GET request:', error);
      return null;
    }
  },

  async removeLot(item) {
    if (process.env.NODE_ENV === 'development') {
      return await mockRequest(true);
    }
    const shoppingCartApiUrl = document.getElementById('shopping-cart').getAttribute('data-shoppingcard-api-url');
    const apiUrl = `${shoppingCartApiUrl}/removelot`;

    try {
      const headers = {
        'Content-Type': 'application/json',
      };

      const body = {
        orderPositionId: item.position,
        isFreeLot: item.isFreeLot,
      };

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      });

      if (response) {
        return await response.json();
      }
    } catch (error) {
      console.error('Error removing lot:', error);
    }
  },

  async redeemCouponCode(couponCode) {
    if (process.env.NODE_ENV === 'development') {
      return await mockRequest(true);
    }

    const couponCodeApiUrl = document.getElementById('shopping-cart').getAttribute('data-couponcode-api-url');
    const apiUrl = `${couponCodeApiUrl}/redeemcouponcode`;

    try {
      const headers = {
        'Content-Type': 'application/json',
      };

      const body = {
        couponCode: {
          code: couponCode,
        },
      };

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify(body),
      });

      if (response) {
        return await response.json();
      } else {
        console.error('Error redeeming coupon code:', response.status);
      }
    } catch (error) {
      console.error('Error redeeming coupon code:', error);
    }
  },

  async deleteCouponCode() {
    if (process.env.NODE_ENV === 'development') {
      return await mockRequest(true);
    }

    const couponCodeApiUrl = document.getElementById('shopping-cart').getAttribute('data-couponcode-api-url');
    const apiUrl = `${couponCodeApiUrl}/delete`;

    try {
      const headers = {
        'Content-Type': 'application/json',
      };

      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers,
      });

      if (response) {
        return await response.json();
      } else {
        console.error('Error removing coupon code:', response.status);
      }
    } catch (error) {
      console.error('Error removing coupon code:', error);
    }
  }
}

export default shoppingCartService;
